import Cart from './pages/cart/cart';
import calculate from './utils/calculate';

const progress = require('./components/progress');

document.addEventListener('DOMContentLoaded', (e) => {
  new Cart().init();

  const $shippingContainer = $('.progress-container');
  const $miniCart = $('.minicart .minicart-subtotal');
  const $valueShipping = $shippingContainer.find('.value-shipping').data('value');
  const $cartContainer = $('.cart.cart-page');

  if ($shippingContainer.length > 0) {
    if (!$miniCart.attr('value')) return;
    const formatValueSubTotal = parseFloat($miniCart.attr('value').replace(',', '.'));
    const subTotals = calculate.progress(formatValueSubTotal, $valueShipping);
    progress.default.build(subTotals, formatValueSubTotal, $cartContainer);
  }
  progress.default.handlerUpdateProgress($cartContainer);
});
